import '.o{display:flex;}.ssr-plugin'
import '.q{gap:8px;}.ssr-plugin'
import '.a9{height:4px;}.ssr-plugin'
import '.f{flex:1;}.ssr-plugin'
import '.dy{border-radius:8px;}.ssr-plugin'
import { styled, Style } from 'inlines'
import { colors } from '../utils/colors.js'
import { transparentColor } from '../utils/transparentcolor.js'

type StepperProps = {
  steps: number
  currentStep: number
  style?: Style
}

export const Stepper = ({ steps, currentStep, style }: StepperProps) => {
  return (
    <styled.div className="o q a9"
      style={{
        ...style,
      }}
    >
      {Array.from({ length: steps }).map((_, index) => (
        <div className="f a9 dy"
          key={index}
          style={{
            backgroundColor:
              index < currentStep ? colors.white : `${transparentColor(colors.white, 0.15)}`,
          }}
        />
      ))}
    </styled.div>
  )
}
